<template>
  
  <UserContentWrapper :title="t('change.avatar')">
    <AppBackButton
          :linkMode="true"
          link="/user/settings"
          class="user-avatar-settings__back"
        />
      <div class="user-avatar-settings">
        
        <div class="user-avatar-settings__preview">
          <AvatarWithCropper
          :avatar="personAvatar"
          @update="$emit('changeAvatar')"
        />
      </div>
    </div>
   
  </UserContentWrapper>
</template>

<script>
import UserContentWrapper from "@/elements/UserContentWrapper.vue";
import AppBackButton from "@/elements/AppBackButton.vue";
import AvatarWithCropper from "./AvatarWithCropper.vue";

import { t } from "@/utils/translate";
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";
import { storeToRefs } from "pinia";

export default {
  emits: ["changeAvatar"],
  components: {
    AppBackButton,
    UserContentWrapper,
    AvatarWithCropper
  },
  setup(_, ctx) {
    const image = ref("");
    const message = ref("ready");
    const userStore = useUserStore();
    const { personAvatar } = storeToRefs(userStore);

    return {
      t,
      personAvatar,
      message,
      image,
    };
  },
};
</script>

<style lang="scss">

.user-avatar-settings {
  margin-top: 5%;
  margin-bottom: 15%;
  &__btns {
   
    display: flex;
    justify-content: space-betweence;
   
  }

  &__save {
    @include button-default;
    margin-left: 16px;
  }

  &__select-photo {
    @include button-default;

    svg {
      stroke: #fff;
      stroke-width: 3px;
    }
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__photo {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;

    img {
      object-fit: cover;
    }
  }

  &__preview {
    position: relative;
    border-radius: 4%;
    overflow: hidden;
    width: 200px;
    height: 200px;
    border: 4px solid $accent-1;
    margin: 0 auto;

   
    .n-avatar {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 768px) {
    &__btns {
      display: block;

      button {
        margin: 0 auto;
      }

      button + button {
        margin-top: 20px;
      }
    }
  }
}

.avatar-cropper-overlay {
  background-color: rgba($text, 0.9);
}
</style>
